import { Component, OnInit, Output, EventEmitter, Input } from '@angular/core';
import { DevicesConstants } from 'src/app/core/routing/services/devices/constants/devices.constants';
import { GlobalConstants } from '../../../common/constants/global.constant';
import moment from 'moment';
import { DeviceStoreService } from '../store/device.store';
import { GoogleAnalyticsService } from '../../google-analytics/google-analytics.service';

@Component({
  selector: 'iposcen-device-auto-shutdown',
  templateUrl: './device-auto-shutdown.component.html',
  styleUrls: ['./device-auto-shutdown.component.scss']
})
export class DeviceAutoShutdownComponent implements OnInit {
  @Output() readonly getShutDownStatus = new EventEmitter();
  @Output() readonly dismissFunc = new EventEmitter();
  @Input() selectLength;
  enableShutStatus = false;
  disableShutStatus = false;
  buttonLabelCancel = DevicesConstants.CANCEL_UPDATE;
  buttonLabelNo = DevicesConstants.NO
  cancelBtn = GlobalConstants.CANCEL;
  saveChanges = GlobalConstants.SAVE_CHANGES;
  cancelChanges = GlobalConstants.CANCEL;
  successMessage = DevicesConstants.DEVICE_UPDATE_SAVED;
  description = DevicesConstants.DEVICE_UPDATE_DESC;
  deviceConst = DevicesConstants;
  isCancel = false;
  openModalPopup = false;
  openSuccessPopup = false;
  editPublishDateInfo: string;
  isSettingsTimeZoneSelected = true;
  shutDownPayload: any;
  sendDefaultTimeZone: string;
  ShutdownSettingsTimezoneObj: any;
  shutDownData: any
  autoShutdownDisable = false;
  autoShutdownEnable = false;
  autoShutdownObj: any;
  storeDataObj: any;
  constructor(private deviceStore: DeviceStoreService, private googleAnalytics : GoogleAnalyticsService) { }

  ngOnInit(): void {
    this.googleAnalytics.devieInfoTabName('Auto_Shutdown');
    const storeData = this.deviceStore?.deviceStoreData;
    if (storeData) {
      this.storeDataObj = JSON.parse(storeData?.settings?.toString());
      this.autoShutdownEnable = this.storeDataObj?.otherSettings?.autoShutDown?.autoShutDownTimeEnabled ? true : false;
      this.autoShutdownDisable = this.storeDataObj?.otherSettings?.autoShutDown?.autoShutDownTimeEnabled ? false : true;
      if (this.autoShutdownEnable) {
        this.editPublishDateInfo = this.storeDataObj?.otherSettings?.autoShutDown ? this.generateTimeTimeZoneData(this.storeDataObj?.otherSettings?.autoShutDown) : '';
      } 
    }
  }

  shutDownCheck(event: any, key: string) {
    if (key === DevicesConstants.SHUTDOWN_ENABLE) {
      this.autoShutdownEnable = true;
      this.autoShutdownDisable = false;
      this.editPublishDateInfo = '';
    } else if (key === DevicesConstants.SHUTDOWN_DISABLE) {
      this.autoShutdownDisable = true;
      this.autoShutdownEnable = false;
    }
  }
  cancel() {
    this.successMessage = DevicesConstants.DEVICE_CANCEL_TITLE;
    this.description = DevicesConstants.DEVICE_CANCEL_DESC;
    this.isCancel = true;
    this.openModalPopup = !this.openModalPopup;
  }
  dismiss() {
    this.dismissFunc.emit('');
    this.openModalPopup = !this.openModalPopup;
    this.isCancel = false;
  }
  closeModal() {
    this.openModalPopup = false;
  }

  closeSuccessModal() {
    this.openSuccessPopup = false;
  }
  sendDataToStore() {
    this.autoShutdownObj = {
      autoShutDown: {
        autoShutDownHour: this.autoShutdownEnable ? (this.shutDownData?.hour || this.storeDataObj?.otherSettings?.autoShutDown?.autoShutDownHour) : '00',
        autoShutDownMin: this.autoShutdownEnable ? (this.shutDownData?.min || this.storeDataObj?.otherSettings?.autoShutDown?.autoShutDownMin) : '00',
        autoShutDownTimeZone: this.autoShutdownEnable ? (this.shutDownData?.timeZone || this.storeDataObj?.otherSettings?.autoShutDown?.autoShutDownTimeZone): this.sendDefaultTimeZone,
        autoShutDownTimeEnabled: this.autoShutdownEnable
      }
    };
    this.shutDownPayload = { settings: JSON.stringify({ otherSettings: this.autoShutdownObj }) };
    this.openModalPopup = !this.openModalPopup;
    this.successMessage = DevicesConstants.DEVICE_UPDATE_SAVED;
    this.description = DevicesConstants.DEVICE_UPDATE_DESC;
    this.deviceStore.updateDeviceData(this.shutDownPayload);
    this.isCancel = false;
    this.getShutDownStatus.emit(true);
    this.googleAnalytics.devieInfoChangesSaved('Idle_Experience');
  }
  generateTimeTimeZoneData(data) {
    return `${moment(data.dateVal).format(GlobalConstants.DATE_FORMAT)} ${data.autoShutDownHour}:${data.autoShutDownMin} ${data.autoShutDownTimeZone}`;
  }

  getTimeTimeZoneData(data) {
    this.shutDownData = data;
  }

  checkTimeZone(data) {
    this.isSettingsTimeZoneSelected = data;
  }

  getDefaultTimeZone(event) {
    this.sendDefaultTimeZone = event;
  }
}
